<template>
    <div class="ordering relative">
        <div
            v-if="! reviewingOrder && data.loaded.all && ! $route.path.startsWith('/order/vps') && order.items.length"
            class="container p-12 pb-0 md:hidden"
        >
            <a
                href="#order-summary-link"
                class="btn btn-primary"
            >View Cart</a>
        </div>

        <div>
            
            <template v-if="processing">
                <div class="container p-12" :class="{
                    'pt-0': orderHome,
                }">
                    <div class="w-full sau-bx text-center py-5">
                        <img src="/img/spinner.gif">
                        <h6 class="sau-pm-reset">Adding {{ itemBeingAdded }}</h6>
                    </div>
                </div>
            </template>

            <template v-else>
                <div v-if="orderHome" class="container p-12">
                    <div class="landing">
                        <div class="flex flex-wrap">
                            <div
                                class="w-full pb-8"
                                :class="{
                                'lg:w-2/3 lg:pr-4': hasActiveOrder(),
                            }"
                            >
                                <div class="flex flex-wrap text-center -m-4 mb-4">
                                    <div
                                        class="w-full p-4 sm:w-1/2"
                                        :class="{
                                        'lg:w-1/2': hasActiveOrder(),
                                        'lg:w-1/3': !hasActiveOrder(),
                                    }"
                                    >
                                        <div class="sau-bx p-6 h-100 flex flex-col">
                                            <i class="fal fa-server d-block mb-3"></i>
                                            <h2>Virtual Data Centre</h2>
                                            <p>A Virtual Data Centre lets you scale your vCPU, Memory &amp; disk allocations to use as you see fit, all powered by the latest hardware offerings from AMD and HPE.</p>
                                            <a
                                                href="https://www.serversaustralia.com.au/products/virtual-data-centre"
                                                target="_blank"
                                                title="Virtual Data Centre"
                                                class="btn btn-success d-block mt-auto"
                                            >View</a>
                                        </div>
                                    </div>
                                    <div
                                        class="w-full p-4 sm:w-1/2"
                                        :class="{
                                        'lg:w-1/2': hasActiveOrder(),
                                        'lg:w-1/3': !hasActiveOrder(),
                                    }"
                                    >
                                        <div class="sau-bx p-6 h-100 flex flex-col">
                                            <i class="fal fa-server d-block mb-3"></i>
                                            <h2>Dedicated Servers</h2>
                                            <p>Blaze and Enterprise series by Servers Australia featuring the power of HPE Gen11 Plus servers. Perfect for virtualisation, databases and high-performance computing.</p>
                                            <router-link
                                                to="/order/dedicated-server"
                                                @click.native="clearSelections()"
                                                class="btn btn-success d-block mt-auto"
                                            >View</router-link>
                                        </div>
                                    </div>

                                    <div
                                        class="w-full p-4 sm:w-1/2"
                                        :class="{
                                        'lg:w-1/2': hasActiveOrder(),
                                        'lg:w-1/3': !hasActiveOrder(),
                                    }"
                                    >
                                        <div class="sau-bx p-6 h-100 flex flex-col">
                                            <svg
                                                aria-hidden="true"
                                                focusable="false"
                                                class="svg-inline--fa fa-wordpress-simple mx-auto mb-2"
                                                style="width: 4.5rem;"
                                                role="img"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 90 90"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m68.2 26.9c-0.8 0-1.8 0.1-2.6 0.2-1.9-9.6-10.6-16.9-20.4-16.9-9.9 0-18.5 7.2-20.4 16.9-0.9-0.1-1.9-0.2-2.8-0.2-10.8 0-19.5 8.8-19.5 19.5 0 10.6 8.6 19.4 19.1 19.6h0.1c1.1 0 2.1-0.9 2.1-2.1s-0.9-2.1-2.1-2.2c-8.2-0.2-14.9-7-14.9-15.3 0-8.4 6.9-15.3 15.3-15.3 1.4 0 2.7 0.2 4.1 0.6l2.6 0.6 0.2-2.6c0.6-8.6 7.8-15.4 16.4-15.4s15.8 6.9 16.4 15.5l0.2 2.6 2.5-0.6c1.3-0.4 2.6-0.5 3.9-0.5 8.4 0 15.3 6.9 15.3 15.3s-6.9 15.3-15.3 15.3c-1.2 0-2.1 0.9-2.1 2.1s0.9 2.1 2.1 2.1c10.8 0 19.5-8.8 19.5-19.5-0.1-10.9-8.9-19.7-19.7-19.7z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m60.5 67.3c0.7 0 1.4-0.6 1.4-1.4v-5.6c0-0.7-0.6-1.4-1.4-1.4h-31.9c-0.7 0-1.4 0.6-1.4 1.4v5.6c0 0.7 0.6 1.4 1.4 1.4h31.9zm-3.6-5.7c0.8 0 1.6 0.7 1.6 1.6 0 0.8-0.7 1.6-1.6 1.6-0.8 0-1.6-0.7-1.6-1.6 0-0.8 0.8-1.6 1.6-1.6zm-26.4 1.2c0-0.7 0.6-1.4 1.4-1.4h18.7c0.7 0 1.4 0.6 1.4 1.4v0.6c0 0.7-0.6 1.4-1.4 1.4h-18.7c-0.7 0-1.4-0.6-1.4-1.4v-0.6z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m60.5 56.6c0.7 0 1.4-0.6 1.4-1.4v-5.6c0-0.7-0.6-1.4-1.4-1.4h-31.9c-0.7 0-1.4 0.6-1.4 1.4v5.6c0 0.7 0.6 1.4 1.4 1.4h31.9zm-3.6-5.7c0.8 0 1.6 0.7 1.6 1.6 0 0.8-0.7 1.6-1.6 1.6-0.8 0-1.6-0.7-1.6-1.6s0.8-1.6 1.6-1.6zm-26.4 1.3c0-0.7 0.6-1.4 1.4-1.4h18.7c0.7 0 1.4 0.6 1.4 1.4v0.6c0 0.7-0.6 1.4-1.4 1.4h-18.7c-0.7 0-1.4-0.6-1.4-1.4v-0.6z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m60.5 45.9c0.7 0 1.4-0.6 1.4-1.4v-5.5c0-0.7-0.6-1.4-1.4-1.4h-31.9c-0.7 0-1.4 0.6-1.4 1.4v5.6c0 0.7 0.6 1.4 1.4 1.4l31.9-0.1zm-3.6-5.7c0.8 0 1.6 0.7 1.6 1.6 0 0.8-0.7 1.6-1.6 1.6-0.8 0-1.6-0.7-1.6-1.6 0-0.8 0.8-1.6 1.6-1.6zm-26.4 1.2c0-0.7 0.6-1.4 1.4-1.4h18.7c0.7 0 1.4 0.6 1.4 1.4v0.6c0 0.7-0.6 1.4-1.4 1.4h-18.7c-0.7 0-1.4-0.6-1.4-1.4v-0.6z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m65.1 77h-39.9c-0.7 0-1.4-0.6-1.4-1.4v-1.1c0-0.7 0.6-1.4 1.4-1.4h40c0.7 0 1.4 0.6 1.4 1.4v1.1c-0.1 0.8-0.7 1.4-1.5 1.4z"
                                                ></path>
                                                <circle
                                                    fill="currentColor"
                                                    class="st0"
                                                    cx="45.1"
                                                    cy="75.2"
                                                    r="4"
                                                ></circle>
                                            </svg>
                                            <h2>Cloud Servers</h2>
                                            <p>Built around the latest HPE Enterprise Servers running on a VMware vSAN solution, Cloud Servers allow you to run your own dedicated operating system, with the added benefit of hardware redundancy and auto fail-over out of the box!</p>
                                            <router-link
                                                to="/order/vps"
                                                class="btn btn-success d-block mt-auto"
                                                @click.native="clearSelections()"
                                            >View</router-link>
                                        </div>
                                    </div>

                                    <div
                                        class="w-full p-4 sm:w-1/2"
                                        :class="{
                                        'lg:w-1/2': hasActiveOrder(),
                                        'lg:w-1/3': !hasActiveOrder(),
                                    }"
                                    >
                                        <div class="sau-bx p-6 h-100 d-flex flex-column">
                                            <svg
                                                aria-hidden="true"
                                                focusable="false"
                                                class="svg-inline--fa fa-wordpress-simple mx-auto mb-2"
                                                style="width: 4.5rem;"
                                                role="img"
                                                viewBox="0 0 90 90"
                                                xml:space="preserve"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m62.4 54.1c1 0 1.8-0.8 1.8-1.8v-5.9c0-1-0.8-1.8-1.8-1.8h-36.7c-1 0-1.8 0.8-1.8 1.8v5.9c0 1 0.8 1.8 1.8 1.8h36.7zm-4.1-6.6c1.1 0 1.9 0.8 1.9 1.9s-0.8 1.9-1.9 1.9-1.9-0.8-1.9-1.9c0.1-1 1-1.9 1.9-1.9zm-30.7 1.7c0-1 0.8-1.8 1.8-1.8h21.3c1 0 1.8 0.8 1.8 1.8v0.2c0 1-0.8 1.8-1.8 1.8h-21.3c-1 0-1.8-0.8-1.8-1.8v-0.2z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m62.4 41.7c1 0 1.8-0.8 1.8-1.8v-5.9c0-1-0.8-1.8-1.8-1.8h-36.7c-1 0-1.8 0.8-1.8 1.8v5.9c0 1 0.8 1.8 1.8 1.8h36.7zm-4.1-6.6c1.1 0 1.9 0.8 1.9 1.9s-0.8 1.8-1.9 1.8-1.9-0.8-1.9-1.9c0.1-0.9 1-1.8 1.9-1.8zm-30.7 1.7c0-1 0.8-1.8 1.8-1.8h21.3c1 0 1.8 0.8 1.8 1.8v0.2c0 1-0.8 1.8-1.8 1.8h-21.3c-1 0-1.8-0.8-1.8-1.8v-0.2z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m62.4 29.3c1 0 1.8-0.8 1.8-1.8v-5.9c0-1-0.8-1.8-1.8-1.8h-36.7c-1 0-1.8 0.8-1.8 1.8v5.9c0 1 0.8 1.8 1.8 1.8h36.7zm-4.1-6.7c1.1 0 1.9 0.8 1.9 1.9s-0.8 1.9-1.9 1.9-1.9-0.8-1.9-1.9c0.1-1 1-1.9 1.9-1.9zm-30.7 1.7c0-1 0.8-1.8 1.8-1.8h21.3c1 0 1.8 0.8 1.8 1.8v0.2c0 1-0.8 1.8-1.8 1.8h-21.3c-1 0-1.8-0.8-1.8-1.8v-0.2z"
                                                ></path>
                                                <path
                                                    fill="currentColor"
                                                    class="st0"
                                                    d="m44 1.5c-19.8 0-35.8 16-35.8 35.8 0 22.8 35.8 51 35.8 51s35.8-28.3 35.8-51c0.1-19.7-16-35.8-35.8-35.8zm0 66.7c-6.1 0-11.7-1.8-16.6-4.8-8.7-5.5-14.4-15.1-14.4-26 0-17 13.8-30.7 30.8-30.7 9.6 0 18.2 4.5 23.9 11.4 4.2 5.3 6.9 12.1 6.9 19.5 0.2 16.8-13.6 30.6-30.6 30.6z"
                                                ></path>
                                            </svg>
                                            <h2>Colocation</h2>
                                            <p>If you need to be in total control of all your hardware and software, colocation in one of our 8 locations will give you control, at better prices than anywhere else in Australia.</p>
                                            <router-link
                                                to="/order/colocation"
                                                class="btn btn-success d-block mt-auto"
                                                @click.native="clearSelections()"
                                            >View</router-link>
                                        </div>
                                    </div>

                                    <div
                                        class="w-full p-4 sm:w-1/2"
                                        :class="{
                                        'lg:w-1/2': hasActiveOrder(),
                                        'lg:w-1/3': !hasActiveOrder(),
                                    }"
                                    >
                                        <div class="sau-bx p-6 h-100 flex flex-col">
                                            <i class="fal fa-globe d-block mb-4"></i>
                                            <h2>Domain Names</h2>
                                            <p>Search for and register the perfect name for your business! Already have one? We also offer quick and easy domain transfers, allowing you to streamline your domain management.</p>
                                            <router-link
                                                to="/order/domain"
                                                class="btn btn-success d-block mt-auto"
                                                @click.native="clearSelections()"
                                            >View</router-link>
                                        </div>
                                    </div>

                                    <div class="w-full p-4 sm:w-1/2" :class="{
                                        'lg:w-1/2': hasActiveOrder(),
                                        'lg:w-1/3': !hasActiveOrder(),
                                    }">
                                        <div class="sau-bx p-6 h-full flex flex-col">
                                            <i class="fal fa-lock-alt block mb-4"></i>
                                            <h2>SSL Certificates</h2>
                                            <p>Secure your server using our industry leading SSL certificates. Choose from a range of  certificate types to match your needs.</p>
                                            <router-link
                                                to="/order/ssl-certificate"
                                                class="btn btn-success block mt-auto"
                                                @click.native="clearSelections()"
                                            >View</router-link>
                                        </div>
                                    </div>
                                </div>

                                <!-- <lets-talk class="my-4"></lets-talk> -->

                                <div class="row my-12">
                                    <div class="col-12 mb-4">
                                        <h4>What our customers think</h4>
                                    </div>
                                    <div class="col-12">
                                        <!-- TrustBox widget - Carousel -->
                                        <div
                                            ref="trustbox"
                                            id="trustbox"
                                            class="trustpilot-widget"
                                            data-locale="en-AU"
                                            data-template-id="53aa8912dec7e10d38f59f36"
                                            data-businessunit-id="5bc4f6217305aa00011cc72e"
                                            data-style-height="160px"
                                            data-style-width="100%"
                                            data-theme="light"
                                            data-stars="4,5"
                                        >
                                            <a
                                                href="https://au.trustpilot.com/review/www.serversaustralia.com.au"
                                                target="_blank"
                                            >Trustpilot</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasActiveOrder()" class="w-full md:w-1/3 md:pl-4">
                                <div id="order-summary-link" class="goto-link-offet"></div>
                                <div class="border md:border-0 md:shadow-sau-lg p-8 bg-white">
                                    <order-summary :order="order" :data="data"></order-summary>
                                </div>
                                <div class="text-center mt-6">
                                    <img
                                        src="/img/geotrust.png"
                                        class="w-full"
                                        style="max-width: 7.5rem !important;"
                                    >
                                    <small
                                        class="text-grey text-xs block"
                                    >Secure payments with GeoTrust 256-bit encryption</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <keep-alive v-if="data.loaded.all"> 🐢🗞 -->
                <template v-if="data.loaded.all">
                    <router-view
                        :order="order"
                        :data="data"
                        :featured-server-hashes="featuredServerHashes"
                    ></router-view>
                </template>
                <!-- </keep-alive> -->

                <div v-else-if="!orderHome" class="p-12 container">
                    <sau-loading></sau-loading>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Helpers from '@js/helpers';
import OrderSummary from './Summary';
import LetsTalk from './partials/LetsTalk';
import jsFunctions from '@js/store/jqueryFunctions';

export default {
    props: {
        active: Object,
        preload: Object,
        defaultHardwareHash: String,
        featuredServerHashes: Array
    },

    components: {
        LetsTalk,
        OrderSummary
    },

    mixins: [jsFunctions],

    provide() {
        return {
            calculateTotals: this.calculateTotals,
            updateItemPromise: this.updateItemPromise,
            removeItemPromise: this.removeItemPromise,
            addOrderItemPromise: this.addOrderItemPromise,
            applyCoupon: this.applyCoupon,
            removeCoupon: this.removeCoupon,
        }
    },

    data() {
        return {
            slug: '',
            items: [],
            tax: 0,
            subtotal: 0,
            subtotalWithDiscount: 0,
            total: 0,
            terms: {},
            isFresh: false,
            readyToOrder: false,
            processing: false,
            itemBeingAdded: '',

            data: {
                order: {
                    slug: '',
                    items: []
                },
                loaded: {
                    order: false,
                    dedi: false,
                    all: false
                },
                active: {
                    dedicatedServer: false,
                    domain: false,
                    managedWordpress: false,
                    vps: false,
                    megaBundle: false,
                    data_centre: null
                },
                config: {
                    domain: [],
                    products: {}
                },
                last: {},
                completeOrder: null,
                coupon: null,
            }
        };
    },

    mounted() {
        window.bus.$on('order.delete', this.deleteOrder);
        window.bus.$on('order.process', this.processOrder);
        window.bus.$on('order.refresh', this.refreshOrder);

        window.bus.$on('order.items.create', this.addItem);
        window.bus.$on('order.items.edit', this.editItem);
        window.bus.$on('order.items.update', this.updateItem);
        window.bus.$on('order.items.delete', this.removeItem);

        window.bus.$on(
            'order.items.addServerToOrderViaHash',
            this.addServerToOrderViaHash
        );

        let vm = this;
        $('a').click(function(event) {
            let $link = $(this);
            let thereArePendingRequests =
                window.store.misc.syncRequestsPending > 0;
            let linkingOutsiteOfOrdering =
                $link.attr('href').indexOf('/order') == -1;

            if (thereArePendingRequests && linkingOutsiteOfOrdering) {
                event.preventDefault();

                vm.$swal({
                    title: 'Saving Your Changes',
                    text: 'Please wait...',
                    imageUrl: '/img/spinner-dark-gray-80.gif',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

                window.bus.$once('request-queue-empty', () => {
                    window.location.href = $link.attr('href');
                });
            }
        });

        this.$store.commit('setActiveSidebar', 'order');

        let promises = [];

        if (this.preload.order) {
            this.slug = this.preload.order.slug;
            this.items = this.preload.order.items;

            this.coupon = this.preload.order.coupon;
            this.tax = this.preload.order.tax;
            this.subtotal = this.preload.order.subtotal;
            this.subtotalWithDiscount = this.preload.order.subtotalWithDiscount;
            this.total = this.preload.order.total;
            this.terms = this.preload.order.terms;

            this.isFresh = true;
            this.readyToOrder = this.preload.order.readyToOrder;

            window.store.orders.loaded = true;
        } else {
            promises.push(
                this.createOrder().then(response => {
                    this.slug = response.data.slug;
                    this.refreshOrder();
                })
            );
        }

        if (this.preload.products) {
            this.data.loaded.dedi = true;
            this.data.config.products = this.preload.products;
        } else {
            promises.push(
                this.getOrderConfigOptions().then(response => {
                    this.data.loaded.dedi = true;
                    this.data.config.products = response.data;
                })
            );
        }

        // This should have loaded from the last block.
        if (!this.data.config.products.rtg) {
            promises.push(
                this.getReadyToGoServers().then(response => {
                    this.data.config.products.rtg = response.data;
                })
            );
        }

        if (this.preload.vps) {
            this.data.vps = this.preload.vps;
        } else {
            promises.push(
                this.getVpsProducts().then(response => {
                    this.data.vps = response.data;
                })
            );
        }

        if (this.preload.domainPricing) {
            this.data.config.domain = this.preload.domainPricing;
        } else {
            promises.push(
                this.getDomainPricing().then(response => {
                    this.data.config.domain = response.data;
                })
            );
        }


        // if (!this.data.config.products.megaBundle) {
        //     promises.push(
        //         this.getMegaBundleProducts().then(response => {
        //             this.data.config.products.megaBundle = response.data;
        //         })
        //     );
        // }

        if (this.active) {
            this.data.active[this.active.product] = this.active.slug;

            // Set the data centre for colocation so we can preselect
            if (this.active.product === 'colocation') {
                this.data.active.data_centre = this.active.data_centre;
            }
        }

        Promise.all(promises).then(() => {
            this.data.loaded.all = true;
        });

        if(window.qualified !== undefined) {
            qualified('identify', { 'email': this.userDetails.email });
        }

    },

    beforeRouteUpdate(to, from, next) {
        if (to.path === '/order') {
            this.clearSelections();
        }

        // If the order has been complete, force a full refresh to start a new order
        if (this.data.completeOrder && to.path != '/order/complete') {
            return window.location.href = to.path;
        }

        next();
    },

    updated() {
        if (document.getElementById('trustbox')) {
            window.Trustpilot.loadFromElement(
                document.getElementById('trustbox')
            );
        }
    },

    methods: {

        goBack() {
            this.$router.back();

            if (
                this.$route.path !== '/order/view' ||
                this.$route.path !== '/order/confirm-domains'
            ) {
                this.clearSelections();
            }
        },

        forceUpdateEverything() {
            this.$forceUpdate();
            let updateAllChildren = function(child) {
                child.$forceUpdate();
                child.$children.forEach(updateAllChildren);
            };
            this.$children.forEach(updateAllChildren);
        },

        calculateTotals() {
            this.isFresh = false;
            if (!Object.keys(this.items).length) return;

            this.tax = this.items
                .map(item =>
                    item.price && item.price.tax ? item.price.tax : 0
                )
                .reduce((a, b) => a + b);

            this.subtotal = this.items
                .map(item =>
                    item.price && item.price.subtotal ? item.price.subtotal : 0
                )
                .reduce((a, b) => a + b);


            this.subtotalWithDiscount = this.coupon ? this.subtotal - this.coupon.discount : this.subtotal;

            this.total = this.items
                .map(item =>
                    item.price && item.price.total ? item.price.total : 0
                )
                .reduce((a, b) => a + b);
        },

        clearSelections() {
            this.data.active.domain = false;
            this.data.active.dedicatedServer = false;
            this.data.active.managedWordpress = false;
            this.data.active.vps = false;
            // this.data.active.megaBundle = false;
            this.data.active.colocation = false;
            this.data.active.sslCertificate = false;

            this.$children.forEach(child => {
                if (child.setItemToEdit) {
                    child.setItemToEdit(null);
                }
            });

            this.forceUpdateEverything();
        },

        fetchItemFromOrder(slug) {
            return this.items.find(item => item.slug === slug);
        },

        refreshOrder() {
            if (!this.slug) {
                window.bus.$emit('order.refresh-failed');
                return;
            }

            this.getOrderSummary(this.slug).then(response => {
                window.store.orders.loaded = true;
                this.updateOrderFromSummary(response.data);
            });
        },

        updateOrderFromSummary(orderSummary) {
            this.items = orderSummary.items;

            this.subtotal = orderSummary.subtotal;
            this.subtotalWithDiscount = orderSummary.subtotalWithDiscount;

            this.tax = orderSummary.tax;
            this.total = orderSummary.total;

            this.coupon = orderSummary.coupon;
            this.terms = orderSummary.terms;

            this.isFresh = true;
            this.readyToOrder = orderSummary.readyToOrder;
            window.bus.$emit('order.refreshed');
        },

        addItem(type, tempData = {}) {
            this.isFresh = false;
            let tempSlug =
                `temp-${type}-` +
                Math.random()
                    .toString(36)
                    .substring(2);
            let tempItem = {
                type: type,
                slug: tempSlug,
                processing: true,
                ...tempData
            };

            this.items.push(tempItem);

            window.bus.$emit('order.items.creating', tempItem);

            this.addOrderItem(this.slug, type)
                .then(response => {
                    let data = { type: type, processing: false };

                    this.items = this.items.map(item => {
                        if (item.slug === tempSlug) {
                            item = { ...item, ...response.data, ...data };
                        }
                        return item;
                    });

                    this.calculateTotals();

                    window.bus.$emit('order.items.created', response);
                })
                .catch(error => {
                    window.bus.$emit('order.items.create-failed', error);
                });
        },

        updateItem(type, itemSlug, data) {
            this.isFresh = false;
            let tempItem;
            this.items = this.items.map(item => {
                if (item.type === type && item.slug === itemSlug) {
                    item = tempItem = { ...item, ...data };

                    if (item.createKey) {
                        delete item.createKey;
                    }
                }

                return item;
            });

            window.bus.$emit('order.items.updating', tempItem);

            this.updateOrderItem(this.slug, type, itemSlug, data)
                .then(response => {
                    this.items = this.items.map(item => {
                        if (item.type === type && item.slug === itemSlug) {
                            item = { ...item, ...response.data };

                            if (item.createKey) {
                                delete item.createKey;
                            }
                        }

                        return item;
                    });

                    this.calculateTotals();
                    this.registerToolTips();

                    window.bus.$emit('order.items.updated', response);
                })
                .catch(error => {
                    window.bus.$emit('order.items.update-failed', error);
                });
        },

        removeItem(item) {
            this.isFresh = false;
            this.items = this.items.filter(searchItem => {
                return item.slug !== searchItem.slug;
            });

            if (item.type == 'domain' && this.$route.path !== '/order/domain') {
                window.bus.$emit('clear-domain-suggestions');
            }

            window.bus.$emit('order.items.deleting', item);

            this.removeItemFromOrder(
                this.slug,
                item.type.toLowerCase(),
                item.slug

                ).then(response => {
                    this.calculateTotals();

                    window.bus.$emit('order.items.deleted', response);
                    window.bus.$emit('order.refresh');
                })
                .catch(error => {
                    window.bus.$emit('order.items.delete-failed', error);
                });
        },

        editItem(item) {
            if (typeof item === 'string' || item instanceof String) {
                item = this.fetchItemFromOrder(item);
            }

            this.clearSelections();

            this.data.active[_.camelCase(item.type)] = item.slug;

            this.$children.forEach(child => {
                if (child.setItemToEdit) {
                    child.setItemToEdit(item);
                }
            });

            this.processing = false;

            if (item.type === 'domain') {
                this.$router.push(`/order/confirm-domains`);
            } else if (item.type === 'vps') {
                this.$router.push(`/order/vps/options`);
            } else if (item.type === 'dedicated-server') {
                this.$router.push(`/order/dedicated-server/custom`);
            } else {
                this.$router.push(`/order/${item.type}`);
            }

            this.forceUpdateEverything();

            window.bus.$emit('fill-active-order-item');
        },

        addServerToOrderViaHash(hardwareHash, customisable = false) {
            let customise = customisable ? 1 : 0;

            this.processing = true;
            this.itemBeingAdded = 'Server';

            window.axios
                .get(
                    `/order/create?dedicated-server=${hardwareHash}&customise=${customise}`
                )
                .then(response => {
                    window.bus.$once('order.refresh-failed', () => {
                        window.location.href = '/order/dedicated-server/custom';
                    });

                    window.bus.$once('order.refreshed', () => {
                        window.bus.$off('order.refresh-failed');
                        window.bus.$emit(
                            'order.items.edit',
                            this.items
                                .filter(
                                    item => item.type === 'dedicated-server'
                                )
                                .pop()
                        );
                    });

                    window.bus.$emit('order.refresh');
                })
                .catch(error => {
                    Vue.rollbar.error(error);
                    this.$swal({
                        type: 'error',
                        title:
                            'Sorry, we were unable to complete your request. Please try again.'
                    });
                });
        },

        deleteOrder() {
            window.bus.$emit('clear-domain-suggestions');

            this.$swal({
                title: 'Cancelling your order.',
                text: 'Please wait...',
                imageUrl: '/img/spinner-dark-gray-80.gif',
                showConfirmButton: false,
                allowOutsideClick: false
            });

            this.syncDeleteRequest(`/api/orders/${this.slug}`).then(() =>
                window.location.replace('/order')
            );
        },

        processOrder() {
            return this.postRequest(`/api/orders/${this.slug}/process`, {
                paymentmethod: this.paymentMethodSelected
            }).then(response => {
                this.data.completeOrder = response.data;
                window.bus.$emit('order.processed', response);

            }).catch(error => {
                window.bus.$emit('order.process-failed', error);

            });
        },

        hasActiveOrder() {
            return (
                this.items && this.items.length && window.store.orders.loaded
            );
        },

        addOrderItemPromise(type, itemData = {}) {
            // Flag the order as needing to be updated - pricing is only calculcated on the front end at this stage
            this.isFresh = false;
            // Generate a temporary entry in the order before hitting the API
            let tempItem = {
                type: type,
                slug:
                    `temp-${type}-` +
                    Math.random()
                        .toString(36)
                        .substring(2),
                processing: true,
                // Pass in any data from the individual item
                ...itemData
            };

            this.items.push(tempItem);

            return new Promise((resolve, reject) => {
                this.addOrderItemNoSync(this.slug, type)
                    .then(response => {
                        let data = { type: type, processing: false };

                        this.items = this.items.map(item => {
                            if (item.slug === tempItem.slug) {
                                item = { ...item, ...response.data, ...data };
                            }
                            return item;
                        });
                        // Run a calc on any prices after the item has been added
                        this.calculateTotals();
                        resolve(response.data);
                    })
                    .catch(error => console.log('Error adding item', error));
            });
        },

        updateItemPromise(type, itemSlug, data) {
            this.isFresh = false;
            this.items = this.items.map(item => {
                if (item.type === type && item.slug === itemSlug) {
                    item = { ...item, ...data };
                    item.processing = true;
                }
                return item;
            });

            return new Promise((resolve, reject) => {
                this.updateOrderItemNoSync(this.slug, type, itemSlug, data)
                    .then(response => {
                        this.items = this.items.map(item => {
                            if (item.type === type && item.slug === itemSlug) {
                                item = { ...item, ...response.data };
                                item.processing = false;
                            }
                            return item;
                        });

                        this.calculateTotals();
                        this.registerToolTips();

                        resolve(response.data);
                    })
                    .catch(error => {
                        console.log('Error updating item', error);
                        reject(error);

                    });
            });
        },

        removeItemPromise(itemToRemove) {
            // Immediately remove it from view
            this.items = this.items.filter(
                item => item.slug !== itemToRemove.slug
            );
            // Recalculate the total before the firing off the request
            this.calculateTotals();
            // Now fire off the request
            return Promise.resolve(
                this.removeItemFromOrder(
                    this.slug,
                    itemToRemove.type,
                    itemToRemove.slug
                )
            );
        },


        applyCoupon(code) {
            return new Promise((resolve, reject) => {
                this.postRequest(`/api/orders/${this.slug}/coupons`, { coupon_code: code})
                    .then(response => {
                        this.updateOrderFromSummary(response.data);
                        resolve(response.data.coupon);
                    })
                    .catch(error => {
                        reject();
                    })
            });
        },

        removeCoupon() {
            return new Promise((resolve, reject) => {
                this.deleteRequest(`/api/orders/${this.slug}/coupons`)
                    .then(response => {
                        this.updateOrderFromSummary(response.data);
                        resolve();
                    })
                    .catch(error => {
                        reject();
                    })
            });
        }



    },

    computed: {
        order() {
            return {
                slug: this.slug,
                items: this.items,
                tax: this.tax,
                subtotal: this.subtotal,
                subtotalWithDiscount: this.subtotalWithDiscount,
                total: this.total,
                isFresh: this.isFresh,
                readyToOrder: this.readyToOrder,
                coupon: this.coupon,
                terms: this.terms,
            };
        },

        screens() {
            return Helpers.screens();
        },

        orderHome() {
            return this.$route.path === '/order' ||
                this.$route.path === '/order/'
                ? true
                : false;
        },

        reviewingOrder() {
            return this.$route.path === '/order/view';
        }
    },

    watch: {
        items: function(val) {
            this.forceUpdateEverything();
            window.bus.$emit('cart-quantity', val.length);
            this.registerToolTips();
        }
    }
};
</script>

<style>
.icon-vps {
    width: 68px;
    text-align: center;
    display: block;
    margin: auto;
    padding-top: 0;
    margin-top: 0;
}
</style>
